import FirstPage from 'components/Icons/FirstPage';
import LastPage from 'components/Icons/LastPage';
import NextPage from 'components/Icons/NextPage';
import PreviousPage from 'components/Icons/PreviousPage';
import React from 'react';
import { PageId } from 'records/Page';
import { PublishRequest } from 'records/PublishRequest';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';

interface Props extends WithAppStoreProps {
  publishRequest: PublishRequest;
  onPageChange: (nextPageId: PageId) => void;
}

class PubReqViewerModalFooter extends React.Component<Props> {
  handleFirstPageClick = (): void => {
    const { appState, onPageChange } = this.props;
    const { publishRequests } = appState;

    const firstPR = publishRequests.first<PublishRequest>();

    onPageChange(firstPR.pageid);
  };

  handlePreviousPageClick = (): void => {
    const { appState, publishRequest, onPageChange } = this.props;
    const { publishRequests } = appState;

    const indexedPRs = publishRequests.toIndexedSeq();
    const currentIndex = indexedPRs.indexOf(publishRequest);

    const futurePR =
      currentIndex === 0
        ? publishRequests.last<PublishRequest>()
        : indexedPRs.get(currentIndex - 1, new PublishRequest());

    onPageChange(futurePR.pageid);
  };

  handleNextPageClick = (): void => {
    const { appState, publishRequest, onPageChange } = this.props;
    const { publishRequests } = appState;

    const indexedPRs = publishRequests.toIndexedSeq();
    const currentIndex = indexedPRs.indexOf(publishRequest);

    const futurePR =
      currentIndex === publishRequests.size - 1
        ? publishRequests.first<PublishRequest>()
        : indexedPRs.get(currentIndex + 1, new PublishRequest());

    if (futurePR.pageid === '') return;

    onPageChange(futurePR.pageid);
  };

  handleLastSheetClick = (): void => {
    const { appState, onPageChange } = this.props;

    const lastPR = appState.publishRequests.last<PublishRequest>();

    onPageChange(lastPR.pageid);
  };

  render(): React.ReactNode {
    const { publishRequest, appState } = this.props;
    const { publishRequests } = appState;

    const pubReqIndex = appState.publishRequests
      .toIndexedSeq()
      .indexOf(publishRequest);

    return (
      <div className=" hs3 w100 flex justify-center shrink-0">
        <div className="row items-center justify-center fill-gray-7">
          <div
            className="mr4 fill-black-h cursor-pointer"
            onClick={this.handleFirstPageClick}
          >
            <div className="wrem-2 hrem-2 flex-center">
              <FirstPage width="22px" height="20px" />
            </div>
          </div>
          <div
            className="fill-black-h cursor-pointer"
            onClick={this.handlePreviousPageClick}
          >
            <div className="wrem-2 hrem-2 flex-center">
              <PreviousPage width="17px" height="20px" />
            </div>
          </div>
          <div className="font-size-4 color-gray-6 mx3">
            {`${pubReqIndex + 1} of ${publishRequests.size}`}
          </div>
          <div
            className="mr4 fill-black-h cursor-pointer"
            onClick={this.handleNextPageClick}
          >
            <div className="wrem-2 hrem-2 flex-center">
              <NextPage width="17px" height="20px" />
            </div>
          </div>
          <div
            className="fill-black-h cursor-pointer"
            onClick={this.handleLastSheetClick}
          >
            <div className="wrem-2 hrem-2 flex-center">
              <LastPage width="22px" height="20px" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withAppStore<Props>(PubReqViewerModalFooter);
